import React from "react";
import { Form, InputGroup } from "react-bootstrap";
//import "./ExitBotIndicatorView.scss";
import {CHANGE_ENTRY_PRICE} from "../../../../actions/create-bot-type";
import { connect,useDispatch } from "react-redux";
import { Trans } from "react-i18next";

const PriceEntryView = (props) => {
  const { newBot } = props;
  const isBuy = newBot.strategy=='Long';
  const side = isBuy ? "Buy" : "Sell";
  const actionTrigger = isBuy ? "less" : "more";
  const dispatch = useDispatch();
  const changePriceEntry = (val) => {
    dispatch({
      type: CHANGE_ENTRY_PRICE,
      payload: val,
    });
  };
  const  restrictAlphabets = (e)=>{
    var x = e.which || e.keycode;
    if(!(x>=46 && x<=57))
      e.preventDefault()
  }
  return (
    <>
      <div>
         <Form.Group>
              <Form.Label>
              <Trans i18nKey={"price-entry-cond"}>{{side}} {{actionTrigger}}</Trans>
              </Form.Label>
                  <InputGroup>
                    <Form.Control
                      as="input"
                      type="number"
                      placeholder=""
                      value={newBot.entryPrice}
                      onChange={(e) => {
                        changePriceEntry(e.target.value);
                      }}
                      onKeyPress={(e) => {
                        restrictAlphabets(e);
                      }}
                    ></Form.Control>
                    <InputGroup.Append>
                      <InputGroup.Text>{newBot.quoteCoin}</InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
            </Form.Group>
      </div>
      
    </>
  );
};

export default connect(null)(PriceEntryView);
